<template>
  <div>
    <v-container
      grid-list-xl
      class="word-wrap pa-0 ma-0 pb-15"
      style="max-width: 100% !important"
    >
      <!-- Banner -->
      <v-layout class="pa-0 ma-0">
        <v-parallax
          height="554"
          style="width: 100%"
          dark
          :src="require('../../../public/images/academy.jpeg').default"
        >
          <v-row align="center" justify="center" class="academyBannerContainer">
            <v-col class="text-center" col="12" style="max-width: 600px">
              <!-- Title -->
              <div
                class="white--text font-weight-regular"
                style="font-size: 42px; letter-spacing: -0.02em"
              >
                <span class="font-weight-black">{{
                  $t("title.batAcademi")
                }}</span
                >{{ $t("title.welcomeAcademy") }}
              </div>

              <!-- Subtitle -->
              <!-- <div
                class="white--text font-weight-regular px-5 mt-4"
                style="font-size: 13px"
              >
                {{ $t("title.academySubtitle") }}
              </div> -->

              <!-- Search -->
              <div class="mt-6 mx-8 whiteInput">
                <v-text-field
                class="whiteInput"
                  v-model="searchTextModel"
                  :label="$t('labels.searchAcademy')"
                  v-on:keyup.enter="searchText"
                  clearable
                  hide-details="auto"
                  clear-icon="mdi-close-circle"
                  append-icon="mdi-magnify"
                  @click:clear="clearSearch"
                  @click:append="searchText"
                  outlined
                  color="white"
                  rounded
                >
                </v-text-field>
              </div>

              <!-- Or -->
              <div
                class="white--text font-weight-regular px-5 mt-4"
                style="font-size: 15px"
              >
                {{ $t("title.or") }}
              </div>

              <!-- Categories -->
              <div class="mt-4">
                <category-menu
                  :items="categories"
                  :loading="categoryLoading"
                  :buttonName="'Kategori Seç'"
                  @clickMenu="(n) => clickCategory(n)"
                />
              </div>
            </v-col>
          </v-row>
        </v-parallax>
      </v-layout>

      <!-- Popular Category -->
      <v-layout
        row
        wrap
        justify-center
        class="mt-10"
        v-if="categories.length > 0"
      >
        <v-flex xs12 md12>
          <div style="max-width: 1355px; margin-left: auto; margin-right: auto;">
            <h4 style="font-size: 24px" class="ml-10 defaultColor--text">
              Popüler Kategoriler
            </h4>
            <v-slide-group class="my-5" active-class="success" show-arrows>
              <v-slide-item
                v-for="(item, i) in categories"
                :key="i"
                class="mr-5"
              >
                <popular-category :item="item" @selectCategory="(n) => clickCategory(n)" />
              </v-slide-item>
            </v-slide-group>
          </div>
        </v-flex>
      </v-layout>

      <!-- Contents -->
      <v-layout
        v-for="(contentItem, i) in contentItems"
        :key="i"
        row
        wrap
        justify-center
        class="mt-10"
      >
        <v-flex xs12 md12>
          <div>
            <h4 style="font-size: 24px" class="ml-10 defaultColor--text">
              {{ contentItem.title }}
            </h4>
            <v-slide-group class="my-5" active-class="success" show-arrows>
              <v-slide-item
                v-for="(item, i) in contentItem.items"
                :key="i"
                class="mr-5"
              >
                <content-card :item="item" />
              </v-slide-item>
            </v-slide-group>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PopularCategory from "../../components/Academy/PopularCategory.vue";
import ContentCard from "../../components/Academy/ContentCard.vue";
import CategoryMenu from "../../components/Academy/CategoryMenu.vue";
import PostService from "../../services/PostService";
import CategoryService from "../../services/CategoryService";
export default {
  data: function () {
    return {
      searchTextModel: "",

      contentItems: [
        {
          title: this.$t('title.lastVideo'),
          items: [],
        },
        {
          title: this.$t('title.lastDocuments'),
          items: [],
        },
        {
          title: this.$t('title.mostLiked'),
          items: [],
        },
      ],

      categories: [],
      categoryLoading: false,

      page: 1,
      pageSize: 10,
    };
  },
  components: {
    PopularCategory,
    ContentCard,
    CategoryMenu,
  },
  methods: {
    searchText() {
      this.$router.push({ path: `/academySearch`, query: { searchText: this.searchTextModel } });
    },

    clearSearch() {},

    getCategories() {
      //TODO: Burada servis ID ile çalışmamalı, key benzeri parametre ile çalışmalı
      let id = "62a1aa366e569d6087ec1b68";
      this.categoryLoading = true;
      CategoryService.getCategories(id)
        .then((res) => {
          if (res.data) {
            this.categories = res.data.Children;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.categoryLoading = false;
        });
    },

    clickCategory(item) {
      console.log("click kategory:", item);
      this.$router.push({ path: `/academySearch`, query: { selectCategory: item } });
    },

    getAcademyLastContent(type = "") {
      setPageLoading(true);
      PostService.getAcademyLastContent(this.page, this.pageSize, type)
        .then((res) => {
          switch (type) {
            case "video":
              this.contentItems[0].items = res.data.Data;
              break;
            case "document":
              this.contentItems[1].items = res.data.Data;
              break;
            case "":
              this.contentItems[2].items = res.data.Data;
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          setPageLoading(false);
        });
    },
  },
  computed: {},
  destroyed() {},
  mounted() {
    this.getCategories();
    this.getAcademyLastContent("video");
    this.getAcademyLastContent("document");
    this.getAcademyLastContent();
  },
  watch: {},
};
</script>

<style>
.academyBannerContainer {
  background-color:rgba(16, 42, 98, 0.76);
}

.whiteInput > .v-text-field fieldset,
.v-text-field .v-input__control,
.v-text-field .v-input__slot {
  /* border-color: white !important;
  color: white !important; */
}

.whiteInput > .v-input__control > .v-input__slot > .v-text-field__slot >.theme--light.v-label {
    color: #ffffff !important;
    font-weight: 500 !important;
}

.whiteInput > .v-input__control > .v-input__slot > .v-text-field__slot > input {
    color: white !important
}

</style>
